<template>
    <div :class="['message-block', msg.received ? 'received' : 'sent']">
        <img v-if="msg.received" :src="userPhoto" alt="" class="message-photo"/>
        <img v-else :src="$store.state.session.user.photo" alt="" class="message-photo"/>
        <p v-if="!msg.file" class="chat-message" v-html="msg.text"></p>
        <audio-player v-else-if="msg.file.contentType.includes('audio')" :secondaryStyle="msg.received" :src="msg.file.fileUrl" class="audio-message"></audio-player>
        <img v-else-if="msg.file.contentType.includes('image')" :src="msg.file.fileUrl" alt="" class="chat-message image-message" @click="showImageFullSize(msg.file.fileUrl)"/>
        <p v-else class="chat-message document"><a :href="msg.file.fileUrl" target="_blank" :download="msg.file.name"><base-button :white="msg.received" :class="[msg.received ? 'received' : 'sent']"><span><b-icon-file-earmark-text></b-icon-file-earmark-text>  {{ msg.file.name }}</span></base-button></a></p>
        <div>
        <span v-if="msg.received || $store.state.chat.selectedChat.user.terminated" class="message-date">{{ appointmentDateFormat(msg.date, true) }}<span v-if="msg.edited"> | {{ $t('edited') }}</span></span>
        <div v-else>
            <span class="message-date"><b-icon-three-dots style="cursor: pointer" @click="toggleShowMsgOptions(msg.chatMessageId)"></b-icon-three-dots><span v-if="msg.edited"> | {{ $t('edited') }}</span> | <b-icon-eye v-if="msg.read"></b-icon-eye> {{ appointmentDateFormat(msg.date, true) }}
            <div v-show="$store.state.chat.showMsgOptions === msg.chatMessageId" class="message-edit-delete" ref="messageMenu">
                <div class="mb-1"><span class="message-edit-element mr-3" v-if="!msg.file" @click="editMessage(msg.chatMessageId)"><b-icon-pencil class="mt-1 mr-1"></b-icon-pencil>{{ $t('edit') }}</span></div>
                <div><span class="message-edit-element delete" @click="$store.commit('chat/toggleShowDialog', 'delete')"><b-icon-trash  class="mt-1 mr-1"></b-icon-trash>{{ $t('chats.delete') }}</span></div>
            </div>
            </span>
        </div>
        </div>
        <div v-if="showFullImage" class="imgFullSize" @click="showImageFullSize()">
            <img :src="showFullImage" alt="" />
        </div>             
        <base-dialog v-model="showDeleteDialog" :content="$t('chats.delete-message')" :okBtnText="$t('yes')" :cancelBtnText="$t('no')" :okFn="() => { $store.dispatch('chat/deleteMessage', msg.chatMessageId) }" :cancelFn="() => { $store.commit('chat/toggleShowDialog', 'delete') }"></base-dialog>
    </div>
</template>
<script>
import AudioPlayer from '@/components/utils/AudioPlayer.vue'
import { appointmentDateFormat } from '@/helpers/date.helpers'
import ChatRepository from '@/repositories/ChatRepository'
import BaseDialog from '@/components/base/BaseDialog'
import { BIcon } from 'bootstrap-vue'
import BaseButton from '@/components/base/buttons/BaseButton.vue'

export default {
    components: {
        AudioPlayer,
        ChatRepository,
        BaseDialog,
        BIcon,
        BaseButton
    },
    props: {
        msg: {
            type: Object,
            required: true
        },
        userPhoto: {
            type: String,
            required: true
        }
    },
    data () {
        return {
          appointmentDateFormat,
          showFullImage: null
        }
    },
    methods: {
      showImageFullSize (src = null) {
        this.showFullImage = src
        if (src) {
          document.body.style.overflow = 'hidden'
        } else {
          document.body.style.overflow = ''
        }
      },
      toggleShowMsgOptions (msgId) {
        this.$store.commit('chat/toggleShowMsgOptions', msgId === this.$store.state.chat.showMsgOptions ? null : msgId)
        if (this.$store.state.chat.showMsgOptions) {
          this.scrollToSeeEditMenu()
        }
      },
      scrollToSeeEditMenu () {
        this.$nextTick(() => {
          var listPos = this.$store.state.chat.refs.messageList.getBoundingClientRect()
          var menuPos = this.$refs.messageMenu.getBoundingClientRect()
          if (menuPos.top <= listPos.top || menuPos.bottom >= listPos.bottom) {
            this.$store.state.chat.refs.messageList.scrollTo({
              top: this.$store.state.chat.refs.messageList.scrollTop + this.$refs.messageMenu.offsetHeight + 2,
              behavior: 'smooth'
            })
          }
        })
      },
      editMessage (msgId) {
        this.$store.commit('chat/setEditingMessage', this.$store.state.chat.selectedChat.messages.find(msg => !msg.received && msg.chatMessageId === msgId))
        this.$store.commit('chat/setNewMessage', this.$store.state.chat.editingMessage.text || '')
      }
    },
    computed: {
        showDeleteDialog: {
          get () {
            return this.$store.state.chat.showDialog.delete && this.$store.state.chat.showMsgOptions === this.msg.chatMessageId
          },
          set (value) {
          }
        }
    }
}
</script>
<style lang="scss" scoped>
.message-block {
  display: block;
  clear: both;
  font-size: 0.9rem;
  padding-bottom: 0.5rem;
}

/deep/.sent {
  float: right;
  p {
    float: right;
    background-color: $blue;
    color: $white;
  a {
      color: $white !important;

      &:hover {
        color: $white !important;
      }
    }
  }
  img {    
    background-color: $blue;
    color: $white;
    float: right;
    cursor: pointer;
  }
  .message-photo {
    float: right;
    margin-left: 10px;
  }
  .message-date {
    float: right;
  }
}

.received {
  float: left;
  p {
    float: left;
    background-color: $secondary;
    color: $blue;
  }
  img {
    background-color: $secondary;
    color: $blue;
    float: left;
    cursor: pointer;
  }
  .message-photo {
    float: left;
    margin-right: 10px;
  }
  .message-date {
    float: left;
  }
}

.chat-message {
  margin: .5rem 0;
  max-width: 80%;
  padding: 10px;
  border-radius: 20px;
  white-space: pre-wrap;

  &.image-message {
    height: 30rem;
    width: 30rem;
    object-fit: cover;
    cursor: pointer;
  }

  &.document {
    box-sizing: content-box;
    button {
      border-width: 1px;
    
      &.sent {
        border-color: $secondary;
      }
      &.received {
        border-color: $blue;
      }
    }
  }
}

.audio-message {
  margin: .5rem 0;
  max-width: 80%;
}

.message-photo {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-top: 0.8rem
}

.message-edit-delete {
  position: relative;
  background-color: $secondary;
  color: $blue;
  border-radius: 20px;
  z-index: 3;
  padding: 0.5rem 1rem;
  width: min-content;
  display: flex;

  .message-edit-element {
    display: flex;
    cursor: pointer;
  }
  .delete {
    color: $red;
  }
}
.message-date {
  display: block;
}

.imgFullSize {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
}

.imgFullSize img {
  max-width: 90%;
  max-height: 90%;
  border-radius: 8px;
}
</style>


// WEBPACK FOOTER //
// src/components/views/chat-interconsultations/ChatMessage.vue